
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("contact/contacts_list_nomatch",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<flexcenter class=\"flexauto sub4\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"contact.nomatch",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":34},"end":{"line":1,"column":62}}})) != null ? stack1 : "")
    + "</flexcenter>";
},"useData":true});
export default TPL;